// extracted by mini-css-extract-plugin
export default {"root":"CenteredLayout_root__+wofL","card":"CenteredLayout_card__Mp6aq","content":"CenteredLayout_content__cispb"};